import { render, staticRenderFns } from "./CuDropSelect.vue?vue&type=template&id=06f58f7a&scoped=true"
import script from "./CuDropSelect.vue?vue&type=script&lang=js"
export * from "./CuDropSelect.vue?vue&type=script&lang=js"
import style0 from "./CuDropSelect.vue?vue&type=style&index=0&id=06f58f7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f58f7a",
  null
  
)

export default component.exports